import "./App.scss";
import HomePage from "../src/search_pages/Homepage/homepage";
import WorkListing from "./search_pages/work/work_listing";
import WorkDetailsMain from "./search_pages/works_details/work_details_main";
import OutletFile from "../src/outlet_file";
import "bootstrap/dist/css/bootstrap.min.css";
import NewsPage from "./search_pages/News_page/newspage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ContactPage from "./search_pages/contact_page/contactpage";
import { useState } from "react";
import { UserContext } from "./use_context";
import JobDetails from "./search_pages/contact_page/JobDetails";
import Career from "./search_pages/contact_page/contact_career";
import Office from "./search_pages/office/office";
import KapilBhalla from "./search_pages/portfolio/kapil-bhalla";
import JobList from "./search_pages/contact_page/JobList";

function App() {
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [heroImage] = useState([]);
  const [workData, setWorkData] = useState([]);
  const [workCategoryData, setWorkCategoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error] = useState(null);
  const [images, setImages] = useState([]);
  const [sliderImages, setSliderImages] = useState([]);
  const [mediaData, setMediaData] = useState({});

  const jobInfo = {
    title: "Lead Interior Designer",
    department: "Interior Design",
    summary: "This is the summary...",
    description: "Detailed job description here...",
    responsibilities: [
      "Lead the design team",
      "Client communication",
      "Project execution",
    ],
    requirements: [
      "5+ years experience",
      "Bachelor’s degree in Interior Design",
    ],
    preferred: ["Experience with luxury projects", "Proficiency in AutoCAD"],
  };
  return (
    <>
      <UserContext.Provider
        value={{
          isLoading,
          workData,
          workCategoryData,
          error,
          images,
          selectedCategoryId,
          sliderImages,
          setSliderImages,
          mediaData,
          setMediaData,
          setWorkData,
          setWorkCategoryData,
          setImages,
          setIsLoading,
          setSelectedCategoryId,
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<OutletFile />}>
              <Route index element={<HomePage />} />
              <Route
                path="/works"
                element={<WorkListing image={heroImage} />}
              />
              <Route path="/homepage" element={<HomePage />} />
              <Route
                path="/worksdetails/:categoryId?"
                element={<WorkDetailsMain />}
              />

              <Route path="/office" element={<Office />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/job-details/:id" element={<JobDetails />} />
              <Route path="/Career" element={<Career />} />
              <Route path="/job/:jobId" element={<JobDetails />} />
              <Route path="/portfolio/kapil-bhalla" element={<KapilBhalla />} />
              {/* Baaki routes yaha */}
            </Route>
          </Routes>
        </BrowserRouter>
      </UserContext.Provider>
    </>
  );
}

export default App;
